import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { GET, httpOk } from 'helpers/api'

import TransferTab from 'pages/admin/duplicate/TransferTab'
import FiscalCodesTab from 'pages/admin/duplicate/FiscalCodesTab'
import CostPriceTab from 'pages/admin/duplicate/CostPriceTab'
import PermissionsTab from 'pages/admin/duplicate/PermissionsTab'
import ServiceTab from 'pages/admin/duplicate/ServiceTab'

/**
 * Инструменты администратора.
 *
 * Раньше это была одна страница «Дубликат», где все ручки лежали в три
 * колонки без подписей: перенос номенклатуры, справочник ИКПУ, раздача прав
 * и рассылка обновлений на кассы. Понять, что делает конкретная кнопка,
 * можно было только по коду. Теперь каждый инструмент — своя вкладка со
 * своей формой и своим результатом.
 *
 * Список логинов нужен трём вкладкам из пяти, поэтому тянется здесь один раз
 * и раздаётся вниз пропсом.
 */
function Index() {
	const { t } = useTranslation()

	const [tab, setTab] = useState('transfer')
	const [users, setUsers] = useState([])

	const TABS = [
		{ 'key': 'transfer', 'name': t('admin_tools_transfer'), 'icon': 'uil-exchange' },
		{ 'key': 'fiscal', 'name': t('admin_tools_fiscal_codes'), 'icon': 'uil-invoice' },
		{ 'key': 'cost', 'name': t('cost_price'), 'icon': 'uil-calculator' },
		{ 'key': 'permissions', 'name': t('permissions'), 'icon': 'uil-lock' },
		{ 'key': 'service', 'name': t('admin_tools_maintenance'), 'icon': 'uil-wrench' },
	]

	async function getUsers() {
		const response = await GET('/admin/helper/users', {}, { loader: true })
		if (httpOk(response)) setUsers(response.data)
	}

	useEffect(() => {
		getUsers()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* align-items-center, а не vertical-center: у .page-header фиксированные
			    40px высоты, и подпись во второй строке налезала бы на вкладки. */}
			<div className="page-header d-flex justify-content-between align-items-center">
				<h4 className="mb-0">
					{t('admin_tools')}
				</h4>
				<div className="text-muted fz-12 text-end d-none d-md-block">
					{t('admin_tools_hint')}
				</div>
			</div>

			<ul className="nav nav-tabs nav-tabs-tools mb-3">
				{TABS.map((item) => (
					<li className="nav-item" key={item.key}>
						<button type="button"
							className={`nav-link ${tab === item.key ? 'active' : ''}`}
							onClick={() => setTab(item.key)}>
							<i className={`uil ${item.icon}`}></i>
							{item.name}
						</button>
					</li>
				))}
			</ul>

			{tab === 'transfer' &&
				<TransferTab users={users} />
			}

			{tab === 'fiscal' &&
				<FiscalCodesTab />
			}

			{tab === 'cost' &&
				<CostPriceTab users={users} />
			}

			{tab === 'permissions' &&
				<PermissionsTab />
			}

			{tab === 'service' &&
				<ServiceTab users={users} />
			}
		</>
	)
}

export default Index
